import React, { useState } from 'react';
import { UnifiedInput } from '../../../components/unified';
import analyticsService from '../../../services/analyticsService';

export default function LoginForm({ onSubmit, loading }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    // Track login attempt
    analyticsService?.trackEvent('login_attempt', {
      method: 'email',
    });
    
    onSubmit(email, password);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <UnifiedInput
        label="Email address"
        type="email"
        value={email}
        onChange={(e) => setEmail(e?.target?.value)}
        placeholder="you@example.com"
        required
        autoComplete="email"
        disabled={loading}
      />
      <UnifiedInput
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e?.target?.value)}
        placeholder="Enter your password"
        required
        autoComplete="current-password"
        disabled={loading}
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <input
            id="remember-me"
            name="remember-me"
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
          />
          <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
            Remember me
          </label>
        </div>

        <div className="text-sm">
          <a href="/forgot-password" className="font-medium text-indigo-600 hover:text-indigo-500">
            Forgot password?
          </a>
        </div>
      </div>
      <button
        type="submit"
        disabled={loading}
        className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Signing in...' : 'Sign in'}
      </button>
    </form>
  );
}